var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70002 16.2028C4.1912 16.2028 5.40004 14.9939 5.40004 13.5028C5.40004 12.0116 4.1912 10.8027 2.70002 10.8027C1.20884 10.8027 0 12.0116 0 13.5028C0 14.9939 1.20884 16.2028 2.70002 16.2028Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 16.2028C14.9911 16.2028 16.2 14.9939 16.2 13.5028C16.2 12.0116 14.9911 10.8027 13.4999 10.8027C12.0088 10.8027 10.7999 12.0116 10.7999 13.5028C10.7999 14.9939 12.0088 16.2028 13.4999 16.2028Z",
    fill: "#BABABA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 16.2028C25.7912 16.2028 27 14.9939 27 13.5028C27 12.0116 25.7912 10.8027 24.3 10.8027C22.8088 10.8027 21.6 12.0116 21.6 13.5028C21.6 14.9939 22.8088 16.2028 24.3 16.2028Z",
    fill: "#BABABA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.ce76d551bbd93f53800850a0a5bb3973.svg";
export { ForwardRef as ReactComponent };